import { Container } from "react-bootstrap";
import ReactPlayer from "react-player";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import MainButton from "component/shared/mainButton/MainButton";

const FALLBACK_VIDEO = "https://www.youtube.com/embed/9WLuF3vjj_U";

export default function VideosTab({ videos }) {
  return (
    <Container
      style={{ backgroundColor: "#EBEBEB" }}
      className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
    >
      <div>
        {videos && Object.keys(videos).length > 0 ? (
          <div className="row gx-md-3 gy-3 gy-md-0">
            <div className="col-12 col-md-6">
              <ReactPlayer
                url={videos[0]?.url ? videos[0]?.url : FALLBACK_VIDEO}
                width="100%"
                height="100%"
              />
            </div>
            <div className="col-12 col-md-6">
              <div className="row gx-md-3 gy-3">
                {videos
                  .map(({ url }, i) => (
                    <div key={i} className="col-12 col-md-6">
                      <ReactPlayer
                        url={url ? url : FALLBACK_VIDEO}
                        width="100%"
                        height="100%"
                      />
                    </div>
                  ))
                  .slice(1, 5)}
              </div>
            </div>
          </div>
        ) : (
          <DataNotFound />
        )}

        <div className="row">
          <label>
            <br />
          </label>
          <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
          <div className="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12">
            <MainButton
              link={"./mediaLanding/media#videos"}
              text={"all-vids"}
            />
          </div>
        </div>
      </div>
    </Container>
  );
}
